module.exports = __webpack_public_path__ + "static/media/notfound.a057b34d.png";